import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { fadeInUp, staggerContainer } from '../../lib/animations';

export const StatsSection = ({ stats }) => {
  const { t } = useTranslation();
  
  const displayStats = [
    { value: `${stats?.suppliers || 48}+`, label: t('home.stats.verifiedSuppliers') },
    { value: `${stats?.products || 137}+`, label: t('home.stats.productsListed') },
    { value: '54', label: t('home.stats.africanCountries') },
    { value: `${stats?.buyers || 21}+`, label: t('home.stats.globalBuyers') }
  ];

  return (
    <section className="bg-charcoal py-12" data-testid="stats-section">
      <motion.div 
        {...staggerContainer}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true }}
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
      >
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {displayStats.map((stat, idx) => (
            <motion.div 
              key={stat.label}
              {...fadeInUp}
              transition={{ delay: idx * 0.1 }}
              className="text-center"
            >
              <p className="font-heading text-4xl lg:text-5xl font-bold text-primary mb-1">{stat.value}</p>
              <p className="text-white/70">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};
